export default function floatingHeader() {
    return {
        isFixed: false,
        anchorTop: 0,
        headerHeight: 0,

        init() {
            const anchor = document.getElementById('header-anchor')
            const header = document.getElementById('header-main-wrap')

            if (!anchor || !header) return

            const recalc = () => {
                // абсолютная позиция якоря в документе
                this.anchorTop = anchor.getBoundingClientRect().top + window.scrollY
                this.headerHeight = header.offsetHeight
            }

            recalc()
            window.addEventListener('resize', recalc)

            window.addEventListener('scroll', () => {
                const shouldFix = window.scrollY >= this.anchorTop

                if (shouldFix && !this.isFixed) {
                    this.isFixed = true
                    document.body.style.paddingTop = this.headerHeight + 'px'
                }

                if (!shouldFix && this.isFixed) {
                    this.isFixed = false
                    document.body.style.paddingTop = ''
                }
            }, { passive: true })
        }
    }
}
